import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from './assets/menu.png'


const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "item" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = { class: "top_navbar" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "catch-me" }, "catchMeTexts[0]", -1)
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "username" }
const _hoisted_10 = { id: "page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_order_page = _resolveComponent("order-page")!
  const _component_order_history = _resolveComponent("order-history")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper", {'active': _ctx.toggleMenu}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (item, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass({'active': index == _ctx.selectedPage }),
              onClick: ($event: any) => (_ctx.selectedPage = index)
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(item), 1)
            ], 10, _hoisted_2)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("img", {
            class: "menu-btn btn",
            alt: "options",
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu = !_ctx.toggleMenu))
          })
        ]),
        _createElementVNode("div", {
          class: "track-box",
          onMouseover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePosition()))
        }, [
          _hoisted_6,
          _createElementVNode("div", {
            class: "user-box",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.stopAnimation()))
          }, [
            _createElementVNode("img", {
              src: _ctx.userImage,
              class: "profile-image",
              alt: "Profile"
            }, null, 8, _hoisted_7),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.profile.given_name), 1)
            ])
          ])
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.selectedPage == 'ORDER')
          ? (_openBlock(), _createBlock(_component_order_page, {
              key: 0,
              onChangePage: _cache[3] || (_cache[3] = (page) => { _ctx.selectedPage = page })
            }))
          : (_ctx.selectedPage == 'ORDER_HISTORY')
            ? (_openBlock(), _createBlock(_component_order_history, { key: 1 }))
            : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}